module.exports =
  template: require('./index.pug')()
  bindings:
    serviceAddons: '<'
    onNew: '&'
    onDelete: '&'
    onEdit: '&'
